export default __webpack_public_path__ + "static/media/question_icon.64525bb7.png";